// 上传图片界面状态类型
export enum EUploadPicPanelType {
    ADD = 'add',
    CANCEL = 'cancel'
}

// 文本框状态（新消息/修改消息）
export enum EInputMesStatusType {
    NEW = 'new',
    MODIFY = 'modify'
}

// 音频播放状态（常态/正在播放）
export enum EAudioPlayStatusType {
    ON = 'on',
    READING = 'reading'
}

// 语音按键状态（default 默认、active 激活、cancel 撤销）
export enum EVoiceBtnPressStatusType {
    DEFAULT = 'default',
    ACTIVE = 'active',
    CANCEL = 'cancel'
}

// 键盘 / 语音状态
export enum EInputStatusType {
    KEYBOARD = 'keyboard',
    VOICE = 'voice'
}